export const INTEGRATOR_ID = 'audi:integrator:csr';
